export default "../assets/dist/main.build.css";